import type { ComponentProps } from 'react';

import { cn } from '../cn';
import { commonIconClassName } from './common';

export const Lightning02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M14.25 2H8.49444C8.31496 2 8.22522 2 8.146 2.02733C8.07593 2.05149 8.01212 2.09093 7.95917 2.14279C7.8993 2.20143 7.85916 2.2817 7.7789 2.44223L3.5789 10.8422C3.38722 11.2256 3.29138 11.4173 3.3144 11.5731C3.3345 11.7091 3.40976 11.8309 3.52246 11.9097C3.65153 12 3.86583 12 4.29444 12H10.5L7.50001 22L19.6931 9.35531C20.1045 8.9287 20.3102 8.7154 20.3222 8.53288C20.3326 8.37446 20.2672 8.22049 20.1459 8.11803C20.0062 8 19.7099 8 19.1172 8H12L14.25 2Z"
      className="opacity-12 fill-current"
    />
    <path
      d="M14.25 2H8.49444C8.31496 2 8.22522 2 8.146 2.02733C8.07593 2.05149 8.01212 2.09093 7.95917 2.14279C7.8993 2.20143 7.85916 2.2817 7.7789 2.44223L3.5789 10.8422C3.38722 11.2256 3.29138 11.4173 3.3144 11.5731C3.3345 11.7091 3.40976 11.8309 3.52246 11.9097C3.65153 12 3.86583 12 4.29444 12H10.5L7.50001 22L19.6931 9.35531C20.1045 8.9287 20.3102 8.7154 20.3222 8.53288C20.3326 8.37446 20.2672 8.22049 20.1459 8.11803C20.0062 8 19.7099 8 19.1172 8H12L14.25 2Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Sun = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z"
      className="opacity-12 fill-current"
    />
    <path
      d="M12 2V4M12 20V22M4 12H2M6.31412 6.31412L4.8999 4.8999M17.6859 6.31412L19.1001 4.8999M6.31412 17.69L4.8999 19.1042M17.6859 17.69L19.1001 19.1042M22 12H20M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Moon01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M22 15.8442C20.6866 16.4382 19.2286 16.7688 17.6935 16.7688C11.9153 16.7688 7.23116 12.0847 7.23116 6.30654C7.23116 4.77135 7.5618 3.3134 8.15577 2C4.52576 3.64163 2 7.2947 2 11.5377C2 17.3159 6.68414 22 12.4623 22C16.7053 22 20.3584 19.4742 22 15.8442Z"
      className="opacity-12 fill-current"
    />
    <path
      d="M22 15.8442C20.6866 16.4382 19.2286 16.7688 17.6935 16.7688C11.9153 16.7688 7.23116 12.0847 7.23116 6.30654C7.23116 4.77135 7.5618 3.3134 8.15577 2C4.52576 3.64163 2 7.2947 2 11.5377C2 17.3159 6.68414 22 12.4623 22C16.7053 22 20.3584 19.4742 22 15.8442Z"
      className="fill-none stroke-current"
    />
  </svg>
);
